import styled from "styled-components";
// import LinkHandler from "./../LinkHandler";

// Shared properies, container
const styledCardContainerShared = `
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1 1 auto;
`;

const StyledCardContainerDesktop = styled.div`
  ${styledCardContainerShared}
`;

const StyledCardContainerTablet = styled.div`
  ${styledCardContainerShared}
`;

const StyledCardContainerMobile = styled.div`
  ${styledCardContainerShared}
`;

const StyledCardContainerLeftDesktop = styled.div`
  ${styledCardContainerShared}
  display: flex;
  flex-direction: row;
  height: 100%;
`;

const StyledCardContainerLeftTablet = styled.div`
  ${styledCardContainerShared}
  display: flex;
  flex-direction: row;
`;

const StyledCardContainerLeftMobile = styled.div`
  ${styledCardContainerShared}
  display: flex;
  flex-direction: row;
`;

const styledCardImageShared = `
  display: flex;
  // justify-content: center;
  align-items: center;
`;

const StyledCardImageDesktop = styled.div`
  ${styledCardImageShared}
  justify-content: center;
`;

const StyledCardImageTablet = styled.div`
  ${styledCardImageShared}
  justify-content: center;
`;

const StyledCardImageMobile = styled.div`
  ${styledCardImageShared}
  justify-content: center;
`;

const styledCardTextShared = `

`;

const StyledCardTextDesktop = styled.div`
  ${styledCardImageShared}
  flex: 1;
`;

const StyledCardTextTablet = styled.div`
  ${styledCardImageShared}
  flex: 1;
`;

const StyledCardTextMobile = styled.div`
  ${styledCardImageShared}
  flex: 1;
  justify-content: center;
`;

const StyledCardContainerOverlayDesktop = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`;

const StyledCardContainerOverlayTablet = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`;

const StyledCardContainerOverlayMobile = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`;

export {
  StyledCardContainerDesktop,
  StyledCardContainerTablet,
  StyledCardContainerMobile,
  StyledCardContainerLeftDesktop,
  StyledCardContainerLeftTablet,
  StyledCardContainerLeftMobile,
  StyledCardImageDesktop,
  StyledCardImageTablet,
  StyledCardImageMobile,
  StyledCardTextDesktop,
  StyledCardTextTablet,
  StyledCardTextMobile,
  StyledCardContainerOverlayMobile,
  StyledCardContainerOverlayTablet,
  StyledCardContainerOverlayDesktop,
};
